"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNumberMask = void 0;
var react_1 = require("react");
function mask0800(result) {
    if (result.length <= 4)
        return result.replace(/^(\d{4})/, "$1 ");
    if (result.length <= 6)
        return result.replace(/^(\d{4})(\d{1,2})/, "$1 $2");
    if (result.length <= 7)
        return result.replace(/^(\d{4})(\d{3})/, "$1 $2 ");
    return result.replace(/^(\d{4})(\d{3})(\d{1,4}).*/, "$1 $2 $3");
}
function phone(result) {
    if (result.match(/^0800/))
        return mask0800(result);
    if (result.length == 0)
        return "";
    if (result.length <= 1)
        return "(" + result;
    if (result.length <= 2)
        return "(" + result + ") ";
    if (result.length <= 5)
        return result.replace(/^(\d{2})/, "($1) ");
    if (result.length <= 6)
        return result.replace(/^(\d{2})(\d{4})/, "($1) $2-");
    if (result.length <= 10)
        return result.replace(/^(\d{2})(\d{4})/, "($1) $2-");
    return result.replace(/^(\d{2})(\d{5})/, "($1) $2-");
}
function date(result) {
    if (result.length == 0)
        return "";
    if (result.length <= 3)
        return result.replace(/^(\d{2})(\d+)*/, "$1/$2");
    return result.replace(/^(\d{2})(\d{2})(\d*)/, "$1/$2/$3");
}
function time(result) {
    if (result.length == 0)
        return "";
    if (result.length <= 2)
        return result;
    return result.replace(/^(\d{2})(\d+)*/, "$1:$2");
}
function datetime(result) {
    if (result.length == 0)
        return "";
    if (result.length <= 3)
        return result.replace(/^(\d{2})(\d+)*/, "$1/$2");
    if (result.length <= 8)
        return result.replace(/^(\d{2})(\d{2})(\d*)/, "$1/$2/$3");
    if (result.length <= 10)
        return result.replace(/^(\d{2})(\d{2})(\d{4})(\d*)/, "$1/$2/$3 - $4");
    return result.replace(/^(\d{2})(\d{2})(\d{4})(\d{2})(\d*)/, "$1/$2/$3 - $4:$5");
}
function cpf(result) {
    if (result.length == 0)
        return "";
    if (result.length <= 5)
        return result.replace(/^(\d{3})(\d+)*/, "$1.$2");
    if (result.length <= 8)
        return result.replace(/^(\d{3})(\d{3})(\d+)*/, "$1.$2.$3");
    return result.replace(/^(\d{3})(\d{3})(\d{3})(\d*)/, "$1.$2.$3-$4");
}
function cnpj(result) {
    if (result.length == 0)
        return "";
    if (result.length <= 5)
        return result.replace(/^(\d{2})(\d+)*/, "$1.$2");
    if (result.length <= 8)
        return result.replace(/^(\d{2})(\d{3})(\d+)*/, "$1.$2.$3");
    if (result.length <= 12)
        return result.replace(/^(\d{2})(\d{3})(\d{3})(\d+)*/, "$1.$2.$3/$4");
    return result.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d*)/, "$1.$2.$3/$4-$5");
}
function doc(result) {
    if (result.replace(/[^\d]/g, '').length <= 11)
        return cpf(result);
    return cnpj(result);
}
function cep(result) {
    if (result.length == 0)
        return "";
    if (result.length <= 5)
        return result;
    return result.replace(/^(\d{5})(\d*)/, "$1-$2");
}
function money(result) {
    result = result.replace(/[^\d]/g, '');
    if (result == '')
        return '';
    result = result.padStart(3, '0').replace(/(\d{2})$/, '.$1');
    var value = parseFloat(result);
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}
var MaskSizes = {
    phone: 15,
    date: 10,
    datetime: 18,
    time: 5,
    cpf: 14,
    cep: 9,
    cnpj: 18,
    money: 19,
    doc: 18
};
var MaskFunctions = { phone: phone, cep: cep, cnpj: cnpj, cpf: cpf, date: date, datetime: datetime, time: time, money: money, doc: doc };
function useNumberMask(opts) {
    (0, react_1.useEffect)(function () {
        if (opts.ref.current == null)
            return;
        var input = opts.ref.current;
        var skipMask = false;
        function maskedValue() {
            var result = input.value;
            result = result.replace(/[^\d]+/g, "");
            result = MaskFunctions[opts.mask](result);
            result = result.substring(0, MaskSizes[opts.mask]);
            if (input.value != result) {
                var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
                nativeInputValueSetter.call(input, result);
                var ev2 = new Event('input', { bubbles: true });
                input.dispatchEvent(ev2);
            }
        }
        var beforeInputLength = 0;
        var wasSelected = false;
        function onKeydown(e) {
            wasSelected = input.selectionStart != input.selectionEnd;
            var canHoldMore = input.value.length < MaskSizes[opts.mask] || wasSelected;
            beforeInputLength = input.value.length;
            if (e.keyCode >= 48 && e.keyCode <= 57)
                return canHoldMore;
            if (e.keyCode >= 96 && e.keyCode <= 105)
                return canHoldMore;
            if (e.keyCode == 13) {
                skipMask = true;
                return;
            }
            if (e.keyCode >= 35 && e.keyCode <= 40) {
                skipMask = true;
                return;
            }
            if (e.keyCode == 8 || e.keyCode == 46) {
                skipMask = true;
                return;
            }
            if (e.keyCode == undefined)
                return;
            if (e.keyCode.toString().match(/^(9|16|17|46|45)$/))
                return;
            if (e.ctrlKey && e.keyCode.toString().match(/^(67|65)$/)) {
                skipMask = true;
                return;
            }
            if (e.ctrlKey && e.keyCode.toString().match(/^(86|90|88|89)$/)) {
                return;
            }
            return e.preventDefault();
        }
        function onKeyup(e) {
            if (skipMask) {
                skipMask = false;
                return;
            }
            var start = input.selectionEnd + (wasSelected ? 0 : 0);
            var wasEnd = start == input.value.length;
            maskedValue();
            if (input.value.length != beforeInputLength && !wasEnd) {
                input.setSelectionRange(start, start);
            }
        }
        function onBlur(e) {
            maskedValue();
        }
        input.addEventListener('keydown', onKeydown);
        input.addEventListener('keyup', onKeyup);
        input.addEventListener('blur', onBlur);
        input.setAttribute("maxlength", MaskSizes[opts.mask].toString());
        maskedValue();
        return function () {
            input.removeEventListener('keydown', onKeydown);
            input.removeEventListener('keyup', onKeyup);
            input.removeEventListener('blur', onBlur);
        };
    }, [opts.ref.current, opts.mask]);
}
exports.useNumberMask = useNumberMask;
;
//# sourceMappingURL=number-mask.js.map